import isNil from 'lodash/isNil';
import { log } from './log';

export const VIEW_HIERARCHY_TOP_YOUR_BORROWBOX = 'yourborrowbox';
export const VIEW_HIERARCHY_TOP_SHOP = 'shop';

export const VIEW_HIERARCHY_SUB_CHECKOUT = 'checkout';
export const VIEW_HIERARCHY_SUB_RESERVE_LIST = 'reserve_list';
export const VIEW_HIERARCHY_SUB_RESERVE_CHECKOUT = 'reserve_checkout';
export const VIEW_HIERARCHY_SUB_RESERVE_DETAIL = 'reserve_detail';
export const VIEW_HIERARCHY_SUB_CATALOGUE = 'catalogue';
export const VIEW_HIERARCHY_SUB_BY_PRODUCT_TYPE = 'productType';
export const VIEW_HIERARCHY_SUB_SELECTIONLIST = 'selectionlist';
export const VIEW_HIERARCHY_SUB_CART = 'cart';
export const VIEW_HIERARCHY_SUB_CHECKOUT_THANKS = 'checkout_thanks';
export const VIEW_HIERARCHY_SUB_ORDERS = 'orders';
export const VIEW_HIERARCHY_SUB_ORDERS_DETAIL = 'orders_detail';
export const VIEW_HIERARCHY_SUB_SEARCH = 'search';
export const VIEW_HIERARCHY_SUB_PRODUCT_DETAIL = 'product_detail';

export const VIEW_HIERARCHY_SUB_BUNDLE = 'bundle';
export const VIEW_HIERARCHY_SUB_BUNDLE_DETAIL = 'bundle_detail';
export const VIEW_HIERARCHY_SUB_BUNDLE_LIST = 'bundle_list';

export const VIEW_HIERARCHY_SUB_ORDER_ASSISTANT = 'order_assistant';
export const VIEW_HIERARCHY_SUB_INCOMPLETE_SERIES = 'incomplete_series';
export const VIEW_HIERARCHY_SUB_COMPLETE_COLLECTION = 'complete_collection';

export const VIEW_HIERARCHY_SUB_YOUR_COLLECTION = 'your_collection';
export const VIEW_HIERARCHY_SUB_COLLECTION_SEARCH = 'collection_search';
export const VIEW_HIERARCHY_SUB_COLLECTION_NEWLY_ADDED = 'collection_newly_added';
export const VIEW_HIERARCHY_SUB_COLLECTION_BY_GENRE = 'collection_by_genre';

export const VIEW_HIERARCHY_SUB_LOCAL_CONTENT = 'local_content';
export const VIEW_HIERARCHY_SUB_LOCAL_CONTENT_PRODUCTS = 'local_content_products';
export const VIEW_HIERARCHY_SUB_LOCAL_CONTENT_COLLECTION = 'local_content_collection';
export const VIEW_HIERARCHY_SUB_LOCAL_CONTENT_PRODUCT_DETAILS = 'local_content_products_detail';
export const VIEW_HIERARCHY_SUB_LOCAL_CONTENT_AUTHORS = 'local_content_authors';

export const VIEW_HIERARCHY_SUB_LIBX = 'libx';
export const VIEW_HIERARCHY_SUB_LIBX_PRODUCT_DETAIL = 'libx_product_detail';
export const VIEW_HIERARCHY_SUB_TERMS_AND_CONDITIONS = 'terms_and_conditions';
export const VIEW_HIERARCHY_SUB_LIBX_FEATURED = 'libx_featured';
export const VIEW_HIERARCHY_SUB_LIBX_NEWLY_ADDED = 'libx_newly_added';
export const VIEW_HIERARCHY_SUB_LIBX_ALL_TITLES = 'libx_all_titles';
export const VIEW_HIERARCHY_SUB_LIBX_GENRES = 'libx_genres';
export const VIEW_HIERARCHY_SUB_LIBX_LOCAL_REGIONS = 'libx_local_regions';

export const VIEW_HIERARCHY_GROUP_LOTE = 'lote_group';
export const VIEW_HIERARCHY_GROUP_LANGUAGE_LEARNING = 'languagelearning_group';
export const VIEW_HIERARCHY_SUB_FOREIGN_LANGUAGE = 'language';
export const VIEW_HIERARCHY_SUB_LOTE = 'lote';
export const VIEW_HIERARCHY_SUB_LOTE_FEATUERD = 'lote_featured';
export const VIEW_HIERARCHY_SUB_LOTE_NEWLY_ADDED = 'lote_newly_added';
export const VIEW_HIERARCHY_SUB_LOTE_GENRES = 'lote_genres';
export const VIEW_HIERARCHY_SUB_LOTE_PRODUCTS = 'lote_all_products';
export const VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING = 'languagelearning';
export const VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_FEATUERD = 'languagelearning_featured';
export const VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_NEWLY_ADDED = 'languagelearning_newly_added';
export const VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_PRODUCTS = 'languagelearning_all_products';
export const VIEW_HIERARCHY_SUB_FOREIGN_LANGUAGE_BUNDLES = 'bundles';

export const VIEW_HIERARCHY_SUB_UNLIMITED = 'unlimited';
export const VIEW_HIERARCHY_SUB_CAMPAIGNS = 'campaigns';

export const VIEW_HIERARCHY_GROUP_MARKETING = 'marketing_group';
export const VIEW_HIERARCHY_SUB_MARKETING_CAMPAIGNS = 'marketing_campaigns';
export const VIEW_HIERARCHY_SUB_LIBRARY_MANAGED_PRODUCT_GROUPS = 'library';
export const VIEW_HIERARCHY_SUB_LIBRARY_MANAGED_PRODUCT_GROUP = 'productgroups_detail';

function _pushTopRoute(viewHierarchy, route) {
    const newViewHierarchy = viewHierarchy.slice(0);
    if (newViewHierarchy.length === 0) {
        newViewHierarchy.push(route);
        return newViewHierarchy;
    }
    log.warning('Top level route can only be pushed into an empty viewHierarchy');
    return null;
}

function _pushGroupRoute(viewHierarchy, groupRoute) {
    const newViewHierarchy = viewHierarchy.slice(0);
    if (newViewHierarchy.length === 1) {
        newViewHierarchy.push(groupRoute);
        return newViewHierarchy;
    }
    log.warning('Group level route can only be pushed into an empty viewHierarchy');
    return null;
}

function _pushSubRoute(viewHierarchy, route) {
    const newViewHierarchy = viewHierarchy.slice(0);
    if (newViewHierarchy.length >= 1) {
        newViewHierarchy.push(route);
        return newViewHierarchy;
    }
    log.warning('Sub route can only be pushed into an viewHierarchy with top-level');
    return null;
}

export default class ViewHierarchy {
    static dropRoutes() {
        return [];
    }

    static pushOrderAssistantRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_SHOP);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_SUB_ORDER_ASSISTANT);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushShopRoute(viewHierarchy, route) {
        let newViewHierarchy = this.dropRoutes(viewHierarchy);
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_SHOP);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushLocalContentRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_YOUR_BORROWBOX);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_SUB_LOCAL_CONTENT);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushLibxRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_SHOP);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_SUB_LIBX);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushBundleRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_SHOP);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_SUB_BUNDLE);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushYourCollectionRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_YOUR_BORROWBOX);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_SUB_YOUR_COLLECTION);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushForeignLanguageRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_SHOP);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_SUB_FOREIGN_LANGUAGE);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushLoteRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_SHOP);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_GROUP_LOTE);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushLanguageLearningRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_SHOP);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_GROUP_LANGUAGE_LEARNING);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushCampaignsRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_SHOP);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_SUB_UNLIMITED);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static pushMarketingRoute(route) {
        let newViewHierarchy = this.dropRoutes();
        newViewHierarchy = _pushTopRoute(newViewHierarchy, VIEW_HIERARCHY_TOP_YOUR_BORROWBOX);
        newViewHierarchy = _pushGroupRoute(newViewHierarchy, VIEW_HIERARCHY_GROUP_MARKETING);
        return _pushSubRoute(newViewHierarchy, route);
    }

    static isComponentInViewHierarchy(viewHierarchy, route) {
        if (isNil(viewHierarchy)) {
            return false;
        }
        return viewHierarchy.includes(route);
    }
}

const getViewHierachyState = state => state?.header?.viewHierarchy;
const isActive = (state, route) => ViewHierarchy.isComponentInViewHierarchy(getViewHierachyState(state), route);

export const isInCatalogue = state => isActive(state, VIEW_HIERARCHY_SUB_CATALOGUE);
export const isInProductType = state => isActive(state, VIEW_HIERARCHY_SUB_BY_PRODUCT_TYPE);
export const isInShopSearch = state => isActive(state, VIEW_HIERARCHY_SUB_SEARCH);
export const isInProducts = state => isActive(state, VIEW_HIERARCHY_SUB_PRODUCT_DETAIL);
export const isInOrders = state =>
    isActive(state, VIEW_HIERARCHY_SUB_ORDERS) || isActive(VIEW_HIERARCHY_SUB_ORDERS_DETAIL);
export const isInOrderAssistant = state => isActive(state, VIEW_HIERARCHY_SUB_ORDER_ASSISTANT);
export const isInBundle = state => isActive(state, VIEW_HIERARCHY_SUB_BUNDLE);
export const isInCart = state => isActive(state, VIEW_HIERARCHY_SUB_CART);
export const isInSelectionlist = state => isActive(state, VIEW_HIERARCHY_SUB_SELECTIONLIST);
export const isInCollectionByGenre = state => isActive(state, VIEW_HIERARCHY_SUB_COLLECTION_BY_GENRE);
export const isInCollectionNewlyAdded = state => isActive(state, VIEW_HIERARCHY_SUB_COLLECTION_NEWLY_ADDED);
export const isInCompleteCollection = state => isActive(state, VIEW_HIERARCHY_SUB_COMPLETE_COLLECTION);
export const isInYourCollection = state => isActive(state, VIEW_HIERARCHY_SUB_YOUR_COLLECTION);
export const isInLoteEntry = state => isActive(state, VIEW_HIERARCHY_SUB_LOTE);
export const isInLoteFeatured = state => isActive(state, VIEW_HIERARCHY_SUB_LOTE_FEATUERD);
export const isInLoteProducts = state => isActive(state, VIEW_HIERARCHY_SUB_LOTE_PRODUCTS);
export const isInLoteNewlyAdded = state => isActive(state, VIEW_HIERARCHY_SUB_LOTE_NEWLY_ADDED);
export const isInLoteGenres = state => isActive(state, VIEW_HIERARCHY_SUB_LOTE_GENRES);
export const isInLanguageLearningFeatured = state => isActive(state, VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_FEATUERD);
export const isInLanguageLearningProducts = state => isActive(state, VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_PRODUCTS);
export const isInLanguageLearningNewlyAdded = state =>
    isActive(state, VIEW_HIERARCHY_SUB_LANGUAGE_LEARNING_NEWLY_ADDED);
export const isInCampaigns = state => isActive(state, VIEW_HIERARCHY_SUB_CAMPAIGNS);
export const isInMarketingCampaigns = state => isActive(state, VIEW_HIERARCHY_SUB_MARKETING_CAMPAIGNS);
export const isInLibraryManagedProductGroups = state =>
    isActive(state, VIEW_HIERARCHY_SUB_LIBRARY_MANAGED_PRODUCT_GROUPS);
export const isInLibraryManagedProductGroup = state =>
    isActive(state, VIEW_HIERARCHY_SUB_LIBRARY_MANAGED_PRODUCT_GROUP);
